
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'generalInfo': 'Algemeen',
	'widgetId': 'Widget-ID',
	'widgetType': 'Widgettype',
	'serviceability': 'Servicegeschiktheid',
	'copyButton': 'Kopiëren',
	'closeButton': 'Sluiten',
	'specification': 'Specificatie',
	'viewSpecification': 'Specificatie bekijken'
});
